// import parseISO from 'date-fns/parseISO'
import formatDate from "@utils/format-date";
import { differenceInDays, differenceInHours, differenceInMinutes} from 'date-fns'
export function membreLevelValidityTime (startedAt = '', expiredAt = '') {
    const started = startedAt ? formatDate(startedAt) : '即日起'
    const expired = expiredAt ? formatDate(expiredAt) : '不限時間'
    const result =  startedAt || expiredAt ? `${started} ~ ${ expired }` : '無期限'
    const excessTime = () => {
        const differenceDays = differenceInDays(expiredAt, new Date())
        const differenceHours = differenceInHours(expiredAt, new Date())
        const differenceMinutes = differenceInMinutes(expiredAt, new Date())
        return differenceDays > 0 ? `${differenceDays}天` : differenceHours > 0 ? `${differenceHours}小時` : `${differenceMinutes}分鐘`
    }
    const isDifferenceInDays = startedAt && expiredAt ? `（剩下${excessTime()}）` : ''
    return result + isDifferenceInDays ?? ''
}